<div mat-dialog-content class="popup-container">
  <div class="popup-content">
    <div class="enviado">
      <button type="button" class="close-button" aria-label="Close" (click)="cerrarModal()">
        <img src="Inmuebles/assets/iconos/close-button.svg" alt="Cerrar">
      </button>
      <img src="Inmuebles/assets/iconos/Operacion_exitosa.png" alt="Imagen del pop-up" class="popup-image" />
      <p class="bold-text">{{ data?.titulo || '¡Formulario enviado con éxito!' }}</p>
    </div>
    <p class="normal-text"
       [innerHTML]="data?.mensaje || 
      'Su información ha sido recibida.<br>
      Un gerente Banorte te contactará en las próximas horas.'">
    </p>
    <button class="btn" (click)="cerrarModal()">Aceptar</button>
  </div>
</div>